import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Layout, Calculator } from 'lucide-react';

interface RBDHeaderProps {
    onCalculate: () => void;
}

export const RBDHeader: React.FC<RBDHeaderProps> = ({ onCalculate }) => {
    return (
        <div className="mb-8">
            <Link to="/analytics/hub" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4">
                <ArrowLeft className="w-4 h-4" />
                Back to Analytics
            </Link>

            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
                        <Layout className="w-8 h-8 text-blue-600" />
                        Reliability Block Diagram (RBD)
                    </h1>
                    <p className="text-gray-600 mt-1">
                        Model system availability and reliability based on component configuration
                    </p>
                </div>

                <button
                    onClick={onCalculate}
                    className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-all shadow-lg font-bold"
                >
                    <Calculator className="w-5 h-5" />
                    Calculate System R
                </button>
            </div>
        </div>
    );
};
